/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 中文 国际化语言文件
 */
// 中文.js
export default {
  centerAgent: {
    subagency: "子代理",
    search: "搜索",
    subagencyIncome: "子代理收入",
    last29Days: "过去29天",
    excludingToday: "不含今天",
    commission: "佣金",
    last30Days: "最近30天数据",
    rank: "排名",
    hostNumber: "主播数量",
    recent30Days: "最近30天主播收入",
    commissionRate: "佣金比例",
    myCommission: "我的佣金",
    remove: "移除",
    thisAction:
      "此操作将从您的团队中移除{hostoragent} {hostname} 。请确认是否继续。",
    dashboard: "数据看板",
    information: "信息",
    dataCenter: "数据中心",
    hostList: "主播列表",
    bdList: "BD列表",
    agencyList: "代理列表",
    myRight: "我的权限",
    numberOf: "代理数量",
    inviteAgency: "邀请代理",
    numberOfHost: "主播数量",
    inviteHost: "邀请主播",
    inviteHostlinkcopied: "邀请链接已复制",
    tipsShare: "提示：将邀请链接分享给你的朋友",
    thisMonthD: "本月数据",
    formDay1: "从 day1 到 day2",
    hostGift: "主播礼物点数",
    agentCommission: "代理佣金",
    currentLevel: "当前等级",
    commissionRateOf: "代理收入佣金率",
    baseSalary: "基本工资",
    stillNeed: "仍然需要",
    toReach: "达到",
    reachedthe: "广告任务",
    advertisementTask: "数据总览",
    dataOverview: "数据总览",
    today: "今日",
    hostPoint: "主播积分",
    agentsPoints: "代理积分收入",
    thisMonth: "本月",
    month: "月份",
    lastMonth: "上月",
    bdNumber: "BD数量",
    hostIncome: "主播收入",
    todayIncome: "今日收入",
    past30Days: "过去30天",
    host: "主播",
    country: "国家",
    level7: "等级 / 7日收益",
    pointIncome: "积分收入",
    liveDuration: "直播时长",
    joinTime: "加入时间",
    state: "状态",
    operation: "操作",
    bd: "BD",
    totalHosts: "主播总收入",
    totalAgents: "代理总收入",
    agent: "代理",
    agentLevel: "代理等级 / 佣金率",
    commissionIncome: "佣金收入",
    showDirect: "仅显示直属代理。不包含今日数据",
    excludingTodayData: "不包含今日数据",
    packages: "套餐",
    contents: "内容",
    balance: "余额",
    release: "发放",
    issue: "发行",
    createBd: "创建BD",
    times: "次",
    authorizeCs: "授权CS",
    giftTo: "赠送给用户",
    bdCreation: "BD创建额度剩余",
    csAuthorization: "CS授权额度剩余",
    giftName: "礼物名称",
    giftContents: "礼物内容",
    check: "检查",
    cancel: "取消",
    tip: "打赏",
    recipientsVip:
      "收礼人VIP等级超过礼物包限制，此礼物的VIP权益将被禁用。确定继续吗？",
    confirm: "确认",
    authorize: "授权",
    inviteBy: "通过用户ID邀请",
    invite: "邀请",
    inviteLink: "邀请链接",
    copy: "复制",
    success: "成功",
    pleaseCheck: "请检查用户ID",
    totalGift:
      "所有主播礼物总收入（不含榜单、任务等平台奖励），包含下级代理的礼物收入。",
    totalAgentsCom: "代理从其主播收入中获得的总佣金，包含下级代理的佣金。",
    allAgent: "所有代理",
    directAgent: "直属代理",
    indirectAgent: "间接代理",
    newUpgraded: "新升级代理",
    newS: "新S级代理",
    newB: "新B级代理",
    newC: "新C级代理",
    expectedReward: "预期奖励",
    newA: "新A级代理",
    agencyLevel: "代理等级",
    nickname: "昵称",
    editNicknameTip: "您每月可免费修改一次代理商名称",
    enterNewNickname: "请输入新昵称",
    nicknameUpdateSuccess: "昵称修改成功",
    cannotEditNickname: "无法编辑昵称",
    cannotEditTip: "您只能免费编辑一次昵称。请联系客服修改昵称。",
    alreadyChangedTip: "您本月已修改过代理商名称。额外修改需要8000金币。",
    payAndSave: "支付并保存",
    upgradeDate: "升级日期",
    bdPolicy: "BD政策",
    agencyDetail: "代理详情",
    agency: "代理机构",
    hostCommission: "主播佣金",
    last6Days: "近6天",
    giftIncome: "礼物收入",
    mins: "分钟",
    agencyCenter: "代理中心",
    myIncome: "今日收入",
    totalHost: "总主播积分",
    overview: "概览",
    hostPoints: "主播积分",
    myHosts: "我的主播积分",
    subagentHost: "下级代理主播积分",
    subagencyNumber: "下级代理数量",
    otherIncome: "其他收入",
    contactAdmin: "联系管理员",
    whatsapp: "WhatsApp",
    bdCenter: "BD中心",
    copySuccess: "复制成功",
    pleaseInput: "请输入充值金额，最低10",
    agencyPolicy: "代理政策",
    agencyCommission: "代理佣金",
    agencyCommission2:
      "代理佣金 = 佣金率 × 所有主播礼物总收入（不含榜单、任务等平台奖励）",
    excludingPlatform: "（不含榜单、任务等平台奖励）",
    agencyCommissionCalculation: "代理佣金计算",
    level: "等级",
    pointsTarget: "积分目标(过去30天)",
    points10000: "10,000 积分 = 1 美元 (M= 百万)",
    note1: "注1：总有效收入 = 您的代理收入 + 您下级各级代理的收入",
    note2: "注2：当主播收到礼物时，代理佣金将实时计入。",
    note3:
      "注3：最低提现金额为10美元，且提现金额必须为10的倍数（例如：10美元、20美元、30美元）。",
    subagencycommission: "下级代理佣金",
    theMain:
      "主代理可从各级下级代理（T1、T2、T3、T4...Tn）的收入中获得佣金，最高佣金率为16%。",
    forExample: "例如：",
    agencyA: "代理A邀请代理B和代理C。",
    agencyB: "代理B邀请代理D和代理E。",
    agencyC: "代理C邀请代理F。",
    noteFigures: "（注：括号内数字代表各代理下属主播的收入）。",
    thusWe: "因此，我们可以计算从代理A到代理F的总有效收入和佣金率。",
    totalValid: "总有效收入 = 您代理的收入 + 下级各层代理的收入",
    aTotal:
      "A总有效收入 = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M（20%佣金率）",
    bTotal: "B总有效收入 = B + D + E = 20M + 20M + 30M = 70M（16%佣金率）",
    cTotal: "C总有效收入 = C + F = 70M + 80M =150M（20%佣金率）",
    dTotal: "D总有效收入 =20M（12%佣金率）",
    eTotal: "E总有效收入 =30M（12%佣金率）",
    fTotal: "F总有效收入 =80M（16%佣金率）",
    subagencyCommission:
      "下级代理佣金 = (主代理佣金率 - 下级代理佣金率) × 下级代理的总有效收入",
    agencyAC: "代理{A}从代理{B}获得的佣金",
    thereforeAgency: "因此，代理{B}从下级代理获得的总佣金",
    sinceAgency: "由于代理D、E和F没有下级代理，因此无法获得下级代理佣金。",
    seniorPolicy: "高级政策",
    nomore: "没有更多数据",
    active: "活跃",
    disabled: "已禁用",
    deleted: "已删除",
    lastLogintime: "最后登录时间",
    onmic: "今日上麦",
  },
  sellerCoin: {
    detailsOf: "提现详情",
    fundsSent: "资金已发放",
    transfer: "转账",
    totalIncome: "总收入",
    orderIncome: "订单收入",
    estimatedReward: "预估奖励",
    amount: "金额",
    applicantId: "申请人ID",
    applicantName: "申请人姓名",
    orderId: "订单ID",
    uploadScreenshot: "上传截图",
    ensureWithdrawal: "请确保提现成功后，上传截图并点击下方按钮通知申请人。",
    remain: "剩余",
    pleasePay: "请立即支付并上传回执。若超时，订单的支付资格将被取消。",
    youCan: "您每天最多可获得 5,000 邀请积分",
    pleaseComplete: "请及时完成提现",
    unableTo: "无法支付，拒绝",
    notifyThe: "通知申请人",
    youCanGet: "及时处理订单可获得1%-3%的额外奖励。",
    ifYou: "30分钟内处理订单可获得3%的奖励。",
    egThe:
      "例如：价值90000积分的订单，您在30分钟内处理，可获得3%的奖励，即90000 × 3% = 2700积分。",
    gotIt: "知道了",
    pleaseUpload: "请上传图片",
    detail: "详情",
    balance: "Balance",
    exchange: "兑换",
    all: "全部",
    recharge: "充值",
    official: "官方",
    exchangeDetail: "兑换详情",
    coinSeller: "币商",
    levelUp: "升级",
    currentLevel: "当前等级",
    myBalance: "我的余额",
    details: "详细信息",
    paymentMethod: "支付方式",
    myOrder: "我的订单",
    paymentMenthod: "支付方式",
    acceptingOrders: "接单中",
    unavailable: "不可用",
    greetingMessage: "欢迎消息设置",
    serviceUnavailable: "服务不可用",
    thisFeature: "此功能暂时被锁定。请联系客服寻求帮助。",
    editMessage: "编辑消息",
    customizeYour: "自定义您的欢迎消息。您可以包含有关充值金币的有用信息。",
    theMessage: "当新用户与您开始私聊时，消息将自动发送",
    save: "保存",
    pleaseEnterMessge: "请输入您的欢迎消息",
    salesMethod: "销售方式",
    user: "用户",
    coinseller: "币商",
    userId: "用户ID",
    check: "检查",
    coinAmount: "金币数量",
    pleaseEnter: "请输入1的倍数",
    enterAt: "请输入至少100，且为1的倍数",
    transferDetails: "转账详情",
    recommendSeller: "推荐卖家",
    recent30Day: "最近30天金币销售",
    whatsapp: "WhatsApp",
    chat: "聊天",
    yourCountry: "您所在的国家目前没有可用的币商。",
    pleaseContact: "请联系客服。",
    customerSupport: "客服支持",
    contact: "联系",
    customRecharge: "自定义充值",
    rechargeDetails: "充值详情",
    myPoints: "我的积分",
    todayRemaining: "今日剩余额度",
    customExchange: "自定义兑换",
    exchangeDetails: "兑换详情",
    rechargeRules: "充值规则",
    sellerLevel: "卖家等级",
    proportion: "比例",
    levelRequirement: "等级要求",
    beginner: "新手",
    singleRecharge: "单次充值",
    standard: "标准",
    senior: "高级",
    exchangeRules: "兑换规则",
    note: "Note",
    seniorCoin: "高级币商每日可按全额汇率兑换最多{point}积分。超过{point}后：",
    beginnerSeller: "新手卖家",
    standardSeller: "标准卖家",
    seniorSeller: "高级卖家",
    claimReward: "领取",
    claimed: "已领取",
    incomplete: "未完成",
    cancel: "Cancel",
    pleaseInput: "Please input the recharge amount, minimum 10",
    pleaseInput2: "请输入充值金额，100K的倍数",
    confirmation: "确认",
    userName: "用户名",
    theUser: "用户已被列入黑名单",
    enterAmount: "输入金额",
    pleaseInput3: "请输入金额",
    theAmount: "金额必须是100000的倍数",
    pleaseInput4: "请输入或选择金额",
    pleaseSelect: "请选择销售方式",
    pleaseInput5: "请输入用户ID",
    atLeast: "至少转移100K金币~",
    pleaseSelect2: "请选择支付方式",
    minimum: "最低",
    theAmount3: "金额必须是1的倍数",
    lessThan: "小于或等于100000",
    orders: "订单",
    applicant: "申请人",
    method: "方法",
    withdrawTime: "提现时间",
    viewDetail: "查看详情",
    toBe: "待确认",
    toBePaid: "待支付",
    toBeCompleted: "待完成",
    completed: "已完成",
    abnormal: "异常",
    refused: "Refused",
    confirmationTimeout: "确认超时",
    paymentTimeout: "支付超时",
    binance: "Binance",
    scanThe: "扫描二维码支付",
    quantity: "数量",
    orderAmount: "订单金额",
    date: "日期",
    payNow: "立即支付",
    payment: "支付",
    pleasePay2: "请按以下方式支付",
    chainName: "链名称",
    contractAddress: "合约地址",
    theAbove: "以上地址仅对此充值有效",
    copy: "Copy",
    notice: "通知",
    pleaseTransfer:
      "请额外转账1 USDT以支付Binance手续费。否则可能会延迟您的金币充值。",
    paymentsMust: "付款必须在0.5小时内完成，否则平台对任何问题不承担责任。",
    add: "添加",
    confirmTo: "确认删除此支付方式",
    countryCurrency: "国家与货币类型",
    selectPayment: "选择您可以汇款的支付方式",
    coinsSeller: "币商规则",
    standrd: "标准",
    salesMethods: "销售方式",
    coinsellerRules: "币商规则",
    whenApplying:
      "申请升级为币商身份时，无需存款要求，只需1次充值即可升级币商等级。如果您选择辞去币商职位，您当前的币商角色将失效",
    youCanReplenish: "您可以直接使用USDT、Epay或通过其他币商为账户充值",
    fraudulentActivities: "Hala平台内严禁欺诈活动。",
    anyViolations: "任何违规行为将导致币商账户终止",
    allRights: "保留所有权利。",
    transferDetail: "转账详情",
  },
  centerHost: {
    baseSalary: "基本工资",
    invitation: "邀请",
    tasks: "任务",
    other: "其他",
    consume: "消费",
    giftIncome: "Gift Income",
    received: "已收到",
    from: "来自",
    luckyGift: "幸运礼物",
    hostCenter: "主播中心",
    noAgent: "无代理",
    last7: "过去7天",
    hourlyIncome: "每小时收入",
    toReach: "to reach",
    rules: "规则",
    pointsOverview: "积分概览",
    totalIncome: "总收入",
    gifts: "礼物",
    workDetail: "工作详情",
    liveDuration: "Live Duration",
    mins: "mins",
    todaysLive: "今日直播记录",
    dailyStatistics: "每日统计",
    startTime: "开始时间",
    endTime: "结束时间",
    duration: "持续时间",
    points: "积分",
    date: "Date",
    giftPoints: "礼物积分",
    removeBinding: "解除绑定",
    thisAction2: "此操作将解除您与{agentName}的绑定。请确认是否要继续解除绑定",
  },
  bombRule: {
    afterThe: "当房间内的引爆值达到一定数量后，礼物炸弹将出现在房间中",
    oneCoins: "房间内收到的1金币=1引爆值",
    itWill: "达到要求后它将自动爆炸，房主将获得相应的金币奖励",
  },
  descriptionLevel: {
    wealth: "财富",
    charm: "魅力",
    wealthValue: "财富值",
    charmValue: "魅力值",
    needTo: "需要",
    send: "发送",
    receive: "接收",
    forThe: "为了升级",
    theRich: "财富等级根据您已充值的金币计算",
    theCharm: "魅力等级根据您收到的金币数量计算",
    LevelLabel: "等级标签",
    level: "Level",
    levelLogo: "等级标志",
  },
  gameRank: {
    gameRank: "游戏排名",
    rules: "Rules",
    thisWeek: "本周",
    lastWeek: "上周",
    agentGaming: "代理游戏收入排名",
    rankingRewards: "排名奖励",
    rankingIs: "排名基于代理房间及其子房间中用户的总投注额。",
    hostRoom: "主播房间收入排名",
    rankingIs2: "排名基于主播房间产生的总游戏收入",
    notes: "备注",
    eventDuration: "活动持续时间：每个日历周。仅当",
    rewardsAre:
      "Rewards are distributed only if the corresponding revenue requirements are met.",
    allRewards:
      "All rewards will be issued within 1-2 working days after the event ends.",
    halaReserves: "Hala保留对此活动的最终解释权",
    rewardsDetail: "奖励详情",
    decorationsPreview: "装饰预览",
  },
  gameLegacyHall: {
    surpriseLucky: "惊喜福袋",
    dailyPlayers: "每日玩家次日可打开福袋获得随机金币",
    eventRule: "活动规则",
    usersSpending: "用户在活动游戏中的消费将计入他们的排名分数",
    thePlatform: "平台将每4小时轮换活动游戏，每次轮换包含4款不同的游戏",
    theTop: "每日前三名玩家将获得相框和金币奖励",
    theTop2: "每周前十名玩家将获得相框和金币奖励",
    usersWho:
      "每天参与活动游戏的用户次日可以打开福袋获得随机数量的金币。您在活动游戏中花费越多，可能获得的金币就越多",
    behindPrevious: "落后于前一名",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    countdown: "倒计时：",
    days: "天",
    winOver: "赢得超过",
    coinsfrom: "单日从游戏中获得的金币",
    earnOver: "赚取超过",
    coinsWitdh: "回报率高达",
    fromOneDay: "从某一天起",
    game: "游戏",
    fromA: "从单次投注中",
    inthisWeek: "在本周内",
    earnUp: "最多可赚取",
    inAsingle: "在单日内",
    eventRules: "活动规则",
    participateIn: "参与游戏以在明天领取更大的福袋",
    youDid: "您没有收到金币奖励。参与游戏，您明天可以继续领取福袋",
    participateIn2: "参与游戏，您明天可以继续领取福袋",
    topDaily: "每日金币赢家榜首",
    topPayout: "最高派彩率赢家",
    topCoins: "每周单轮金币赢家榜首",
    topPayout2: "每周单轮最高派彩率赢家",
    topWeekly: "每周金币赢家榜首",
    historicalTop: "历史单日金币赢家榜首",
    historicalTop2: "历史单日最高派彩率赢家",
    historicalTop3: "历史单轮金币赢家榜首",
    historicalTop4: "历史单轮最高派彩率赢家",
    historicalTop5: "历史单周金币赢家榜首",
    gameReward: "游戏奖励",
    usersSpending2: "用户在活动游戏中的消费将计入他们的排名分数",
    theTop3: "每日前三名玩家将获得相框和金币奖励",
    theTop4: "每周前十名玩家将获得相框和金币奖励",
    usersWho2:
      "每天参与活动游戏的用户次日可以打开福袋获得随机数量的金币。您在活动游戏中花费越多，可能获得的金币就越多",
    coins: "硬币",
    flameRider: "火焰骑士",
    sportCar: "跑车",
    captainMeow: "喵队长",
    profileFrame: "头像框",
  },
  gold: {
    coinsDetail: "金币详情",
    coinBalance: "金币余额",
    all: "ALL",
    sendGifts: "发送礼物",
    purchaseItems: "购买物品",
    games: "游戏",
    exchange: "Exchange",
    recharge: "Recharge",
    activeReword: "活动奖励",
  },
  integral: {
    all: "All",
    cashOut: "提现",
    transfer: "Transfer",
    withdrawDetail: "提现详情",
    orderId: "Order ID",
    paymentMenthod: "Payment Menthod",
    withdrawalTime: "提现时间",
    pointsAmount: "积分数量",
    depositAmount: "存款金额",
    coinsAmount: "金币数量",
    transferTo: "转账至",
    normal: "正常",
    pending: "待处理",
    success: "Success",
    failed: "失败",
    points: "Points",
    pointsBalance: "积分余额",
    frozenPoints: "冻结积分",
    details: "详细信息",
    exchange: "Exchange",
    currencyType: "货币类型",
    paymentMethod: "Payment method",
    pointsAmount2: "提现积分数量",
    enterA: "请输入100,000的倍数（最低200,000）",
    enterA2: "请输入100000的倍数",
    accountInformation: "账户信息",
    withdraw: "提现",
    amount: "金额",
    exchangeRate: "汇率",
    exchangePoints: "兑换积分",
    enterUserId: "输入用户ID",
    check: "Check",
    fee: "费用",
    theAgency: "代理将收到",
    transferFee: "转账手续费：2%。最低转账≥100,000积分。",
    clickTransfer: "点击转账按钮将相应积分转账给您的代理",
    afterThe2: "转账完成后，无法取消或撤回",
    transferPoints: "转账积分",
    recommendedMethod: "推荐方式",
    lowerFees: "较低的费用并在24小时内审核",
    paymentPassword: "未设置支付密码",
    cashOut2: "提现和兑换需要支付密码验证。请先设置您的支付密码。",
    cancel: "Cancel",
    goTo: "前往设置",
    youHave:
      "您已连续失败5次。再次失败将导致账号被冻结。如忘记密码，请及时重置。",
    inputIncorrect: "多次输入错误密码。您的账户已被冻结，请于之后重试",
    verify: "验证",
    gotIt: "Got it",
    pointsInfo: "积分信息",
    whenA:
      "当用户使用通过Google充值的金币向您发送礼物时，您收到的积分将被冻结7天后方可用。如果用户要求退款，这些积分将被扣除。请遵守平台规则，避免任何违规行为。",
    frozenPointsAre: "冻结积分包含在总积分余额中",
    theUser2: "用户已被列入黑名单",
    successfulWithdrawal: "提现成功",
    withdrawalAmount: "提现金额",
    theFunds: "资金将在24小时内到账",
    pleaseEnter2: "请输入密码",
    passwordIncorrect: "密码错误",
    theAmount4: "金额必须是100000的倍数",
    pleaseEnter3: "请输入用户ID",
    pleaseEnter4: "请输入正确的用户ID",
    pleaseEnter5: "请输入金额",
    minimumTransfer: "最低转账≥100,000积分",
    pleaseSelect3: "请选择方式",
    minimum: "minimum",
    theAmount5: "金额必须小于",
    illegalInput: "非法输入",
    pleaseEnter6: "请输入账户信息",
  },
  invite: {
    inviteGame: "邀请游戏用户",
    currentRebate: "当前返利",
    need: "需要",
    toProgress: "升级到下一级",
    gameReward: "Game Reward",
    referralData: "推荐数据",
    referralList: "推荐列表",
    date: "Date",
    gameBets: "游戏投注",
    inviteRewards: "邀请奖励",
    viewMore: "查看更多",
    inviteFriends: "邀请朋友",
    myReward: "我的奖励",
    totalRewards: "总奖励",
    dailyReward: "每日奖励",
    inviteRules: "邀请规则",
    yourRebate: "您的返利率取决于您过去30天的总有效投注额",
    totalValid2: "总有效投注 = 您的自身投注 + 您邀请的每一级用户的自身投注",
    rebateFrom: "来自一级邀请用户的返利 = 他们的自身投注 × 您的返利率",
    rebateFrom2:
      "来自二级邀请用户的返利 = 他们的自身投注 × (您的返利率 - 一级返利率)",
    ifThe:
      "如果二级邀请用户邀请三级用户，可以增加他的总有效投注，但他无法从三级获得返利。",
    example: "示例",
    tier1: "一级邀请 - 如何计算直接由您邀请的人的返利？",
    asRebate:
      "A从B、C和D获得的返利 = (B的自身投注 + C的自身投注 + D的自身投注) × A的返利率 =",
    bsRebate: "B从E和F获得的返利 = (E的自身投注 + F的自身投注) × B的返利率 =",
    csRebate: "C从G获得的返利 = G的自身投注 × C的返利率 =",
    tier2: "二级邀请 - 如何计算由您间接邀请的人的返利？",
    asRebate2:
      "A从E和F获得的返利 = (A的返利率 - B的返利率) × (E的自身投注 + F的自身投注) =",
    asRebate3: "A从G获得的返利 = (A的返利率 - C的返利率) × G的自身投注 =",
    myInvitation: "我的邀请",
    search: "Search",
    invitationTime: "邀请时间",
    inviteHost: "Invite Host",
    inviteA: "邀请主播，每个最高",
    todayRewards: "今日奖励",
    rewardDetail: "奖励详情",
    creatorRewards: "创作者奖励钱包",
    collect: "领取",
    invitationDate: "邀请日期",
    hostPolicy: "主播政策",
    halaReserves2: "Hala保留对上述政策的最终解释权。",
  },
  listContribution: {
    contributiont: "贡献",
    host: "Host",
    wealth: "Wealth",
    today: "Today",
    yesterday: "昨日",
    game: "Game",
    gift: "礼物",
    hostEarnings: "主播收益",
  },
  missionRule: {
    hostPolicy: "Host Policy",
    halaReserves3: "Hala保留对上述政策的最终解释权",
  },
  purchase: {
    recharge: "Recharge",
    userId: "User ID",
    confirm: "Confirm",
    switchAccount: "切换账户",
    countryRegion: "国家/地区",
    officialAgency: "官方代理充值",
    ttOff: "8折",
    totalAmount: "总金额",
    purchase: "购买",
    pleaseComfirm: "请确认用户ID",
    pleaseInput8: "请输入用户ID",
    onlineService: "在线客服",
    dealOf: "过去30天交易",
    recent30Day2: "最近30天金币销售",
    paymentMethod: "Payment Method",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry2: "您所在的国家目前没有可用的币商",
    pleaseContact2: "请联系客服。",
    customerSupport: "customer support",
    contact: "Contact",
  },
  roomGiftRule: {
    eventRules: "Event Rules",
    treasureChest: "宝箱进度通过在房间内赠送礼物增加",
    whenThe: "当宝箱钥匙进度条填满时，宝箱将打开",
    afterThe3: "3级和4级宝箱满足要求后，将被锁定1分钟然后自动打开",
    everyoneIn:
      "Everyone in the room has a chance to get the rewards in the treasure chest",
    onceThe:
      "Once the treasure chest is opened, it may take several minutes for the system to issue the reward to your account. The gold coins will be added to your balance and the costume will be added to your inventory",
    theHigher:
      "The higher the level of the treasure chest, the bigger the rewards in it",
    ifYou2:
      "If you are selected as a VIP with a lower VIP level than your current one, the VIP level will not take effect",
    theProgress:
      "The progress bar of the chest key will be reset at 00:00 (UTC+5:30) everyday",
  },
  share: {
    joinHala:
      "Join Hala to unlock multiple earning opportunities and enjoy tailored benefits and rewards for Agencies.",
    downloadTo: "Download to Become a Partner",
    joinHala2: "加入 Hala，畅玩趣味游戏，赢取丰厚奖品。",
    downloadAnd: "下载并开始赢取胜利",
    joinHala3: "加入 Hala，开启您的主机托管之旅。每日最高可赚取 36 美元奖励！",
    inviteYou: "邀请您加入机构",
    downloadNow: "立即下载，开始托管",
    comeWith: "跟我一起加入Hala的聊天室吧",
    enthusiastsFrom: "来自世界各地的爱好者齐聚一堂，分享……",
    igniteEndless: "点燃无尽的乐趣",
    download: "下载",
    halaLive: "Hala Live",
    showMe: "让我看到快乐的世界",
    saySomething: "说些什么...",
    downloadHala: "下载 Hala 应用",
  },
  starHost: {
    starHost: "明星主持人",
    level2: "{level} 级维持了 {days} 天",
    currentSalary: "目前薪资",
    points: "Points",
    likes: "点赞",
    stillNeed: "Still need",
    done: "完毕",
    numberOf2: "送礼者人数",
    gifters: "赠送者",
    gcoinGifts: "Gcoin 礼物",
    gifts: "gifts",
    liveDuration: "Live Duration",
    min: "最小",
    completeAll: "完成以下所有任务即可升级",
    follower: "追随者",
    numberOf3: "送礼者人数",
    daysAt: "{level}级天数",
    giftCollection: "礼品系列",
    gift: "Gift",
    date: "Date",
    expectedSalary: "期望薪资",
    gcoin: "Gcoin",
    status: "地位",
    levelReached: " 已达到级别",
    notAchieved: "未达成",
    starHost2: "明星主持人规则",
    eachStar: "每位明星主持人都有3天的试用期。",
    theyWill: "只有在连续三天都达到A级标准，他们才能成为正式的明星主持人。",
    thoseWho: "未能达到每日A级考试目标者将被解雇。",
    firedHosts: "被解雇的主持人无法获得明星主持人的基本工资",
    starHost3: "明星主持人的基本工资每周一发放。",
    ifA: "如果明星主播未能完成每日任务，则只能获得时薪的50%。",
    selfGifting: "严禁向所有受赠人自费。",
    starHost4: "不同等级的明星主持人奖励",
    level: "Level",
    dailyExtra: "每日额外积分奖励",
    liveBroadcast: "直播所需时间",
    starHost5: "不同级别的明星主持人要求",
    requirements: "要求）",
    yourApplication: "您的申请已获官方批准",
    stayOn: "在A级住宿7天",
    over1k: "超过1000名粉丝",
    totalGifter: "捐赠者总数 > 300",
    receiveAll: "领取所有“幸运”礼物",
    everyLucky: "每个幸运礼物号码都应该大于100。",
    stayOn2: "在S级停留10天",
    over2k: "超过2000名粉丝",
    totalGifter2: "送礼者总数> 300",
    receiveAll2: "领取所有“热门”礼物",
    stayOn3: "在SS级停留10天",
    over5k: "超过5000名粉丝",
    totalGifter3: "捐赠者总数 > 1000",
    receiveAll3: "领取所有“豪华”礼品",
    starHost6: "明星主持人每日任务",
    dailyAssessment: "（每日评估系统）：互动/礼物",
    gcionGifts: "Gcion礼品",
    rulesTo: "降低星际宿主等级的规则",
    failTo: "连续3天未能达到当前级别的标准。",
    failingTo: "一周内未能达到标准3次",
    ifThe2:
      "如果未能达到每日要求的主持人是A级，将被直接解雇，而不是降级。降级后，主持人必须连续3天达到原级别的标准才能恢复到A级。",
    involvementIn: "参与重大违规行为或负面事件。",
    causingDamage: "损害平台利益或品牌形象",
    applyFor: "自行申请辞职",
    liveStreaming: "直播要求",
    liveStream: "直播内容必须符合主持人指定的类型。",
    roomHosts: "直播期间，主持人禁止长时间将麦克风静音。",
    liveStreams: "直播必须使用9座麦克风房间布局进行。",
    otherSeats:
      "房间内的其他座位不允许被为了刷任务而将麦克风静音的用户或观众占用。",
    discriminatoryInsulting: "房间内严禁发表歧视性、侮辱性或冒犯性言论。",
  },
  starRoom: {
    afterCountdown: "每日倒计时结束后，星级客房排行榜前三名将位列其中。",
    top20Star: "本周结束后，排名前 20 的星级客房将获得丰厚的奖励。",
    countdown: "Countdown：",
    top3Daily: "每日排名前三的房间将有资格加入每周星级房间计划。",
    starRooms:
      "星级房间的排名将在每周最后一天进行。排名将根据每个房间的总金币流入量来确定。",
    top20Weekly: "每周排名前 20 的星级房主将获得以下奖励",
    qualificationTo:
      "参与本次活动的资格：任何违规或非法行为均不被允许，一旦发现，Hala 将取消该房间的参赛资格并将其从等级中移除。",
    theRewards: "奖励将于每周一发放。",
    days: "days",
    coins: "Coins",
  },
  inviteActive: {
    inviteHosts: "邀请主持人",
    pointsMax: "每日最高积分 5,000 点",
    firstRecharge: "首次充值用户",
    get20: "免费领取 20 美元",
    oneInvite:
      "1.邀请主持人开始直播，当您邀请的主持人结束直播后，再邀请他们开始直播。",
    aFinish: "a. 在任务中心完成人脸验证",
    bCreate: "b. 为她打造自己的房间",
    cLive: "c.在她房间里对着麦克风直播了3个小时",
    dClaim: "d.首次领取直播奖励",
    youGet:
      "您每天都能从您有效邀请的主持人的号码中获得积分奖励。您可以于次日领取奖励。",
    validHost: "有效主机",
    pointsReward: "积分奖励",
    youCan: " You can earn up to 5,000 invite points per day",
    myInvited: "我邀请的主人",
    validHosts: "今日有效主机",
    pointsRewards: "积分奖励",
    validHosts2: "昨日有效主机：",
    claim: "领取",
    claimed: "已领取",
    completedTime: "完成时间",
    ifYour:
      "如果你的朋友完成首次充值，你将获得丰厚奖励。（线下充值也包含在内）。",
    theMore: "首次充值金额越高，获得的金币奖励就越多，每天最高可达 20 美元。",
    inviteesRecharge: "受邀者充值金币",
    yourReward: "您的奖励金币",
    threeOnly: "3.只有在30天内受邀充值的用户才会被计入有效的首次充值用户。",
    seniorAnd:
      "高级卖家和普通卖家只有在首次通过应用程序或官方渠道充值（请联系管理员了解支付方式）时才会被计入，首次充值用户将被计入有效用户数。",
    myInvited2: "我邀请的用户",
    rechargeCoins: "充值币",
    coinsRewards: "金币奖励",
    firstRecharge2: "昨日首充值金币：",
    firstRecharge3: "首次充值币",
    firstRecharge4: "首次充电时间",
  },
  hostPolicy: {
    title: "主播政策",
    section1Title: "新主播首周基础薪资",
    requirement: "要求",
    newHostsDesc: "在第一周加入Hala的新主播",
    activeTime: "麦上活跃时长",
    oneHour: "1小时",
    twoHour: "2小时",
    threeHour: "3小时",
    baseSalary: "基础薪资（积分）",
    incomeRequirement: "收入要求",
    none: "无",
    remarks: "备注",
    remarksDesc: "每天最多3小时。最多7天。总奖励最高35,000积分",
    note1: "从主播注册之日起，7天基础薪资有效期开始倒计时。",
    note2: "使用多个账户或使用多个IP或设备登录的主播将被取消基础薪资奖励资格。",
    note3:
      "如果主播最近7天收入超过150,000积分，她将获得普通主播时薪奖励而不是新主播基础薪资奖励。",
    section2Title: "普通主播平等奖励",
    level: "等级",
    incomeRequirementShort: "收入要求",
    hourlyReward: "时薪奖励",
    maximumDailyHours: "每日最大时长",
    section2Note1: "在麦上连续15分钟将被计为有效时间。",
    section2Note2: "所有奖励以积分结算，需要在任务系统上领取。",
    section2Note3: "平台奖励不会计入积分要求。",
    section2Note4: "一旦检测到多个IP或设备，积分将被扣除。",
    section2Note5:
      "过去7天意味着过去6天+今天，因此您的时薪奖励可能会随着您及时达到更高的积分等级而增加。",
    section2Note6:
      "L级无目标奖励仅在注册后的前7天有效。7天后，主播可以永久每天获得500免费积分。",
    section3Title: "主播规定",
    regulation1: "禁止主播注册多个账户。",
    regulation2: "禁止推广第三方平台。",
    regulation3: "严禁未成年人。",
    regulation4:
      "一个主播只能有一个已验证的ID。只有已验证的ID才能开始直播和提现收益。",
    regulation5: "任何冒充人脸认证开始直播或提现收益的行为将被永久封禁。",
    regulation6: "向他人提供ID进行直播将导致该ID被系统永久封禁。",
    regulation7: "在语音房间里，主播必须主动问候进入房间的用户。",
    regulation8: "语音房间封面照片必须使用主播真实、合规的照片。",
    regulation9:
      "Hala平台严格禁止任何欺诈行为。任何违规行为将导致永久账户暂停。",
    footer: "Hala保留对上述政策的最终解释权。",
  },
  correspondingRevenue: "相应的收入要求满足时。所有奖励将在",
  within12: "活动结束后1-2个工作日内",
};
